module.exports = __webpack_public_path__ + "img/104001.ccf557e7.png";